import { render } from "./Setup2FA.vue?vue&type=template&id=6dcd53e9&scoped=true"
import script from "./Setup2FA.vue?vue&type=script&lang=js"
export * from "./Setup2FA.vue?vue&type=script&lang=js"

import "./Setup2FA.vue?vue&type=style&index=0&id=6dcd53e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcd53e9"]])

export default __exports__